import { FaChevronUp, FaChevronDown, FaTrash } from "react-icons/fa";

import { LiaRupeeSignSolid } from "react-icons/lia";

import { Button, Image, Loader } from "../../../components/shared";

import { getImageUrl } from "../../../lib/get-image";

import toast from "react-hot-toast";

import { Link } from "react-router-dom";

const CartMainContent = ({
  cartItems, 
  isLoading,
  removeItem,
  updateQuantityInc,
  updateQuantityDec,
  styles,
  selectedItems,
  handleSelectItem,
}) => {
  return (
    <>
      {isLoading ? (
        <div className={styles.cartLoader}>
          <Loader title="Loading carts data.." />
        </div>
      ) : cartItems?.length === 0 ? (
        <div className={styles.emptyCartWrapper}>
          <p className={styles.emptyCartText}>Please add product to proceed</p>
        </div>
      ) : (
        <div className={styles.cartItemsWrapper}>
          {/* =================================================
              TABLE HEADER
          ================================================= */}

          <div className={styles.tableHeader}>
            <div>Select</div>

            <div>Remove</div>

            <div>Image</div>

            <div>Product</div>

            <div>Unit Price</div>

            <div>Quantity</div>

            <div>Total</div>
          </div>

          {/* =================================================
              CART ITEMS
          ================================================= */}

          {cartItems.map((item) => {
            const maxQty = Number(item?.product?.qty || 0);

            const isMaxReached = maxQty > 0 && item.quantity >= maxQty;

           const productPrice = Number(
  item.variant?.price ??
    item.price ??
    item.product?.price ??
    0
);

const offerPrice =
  item.variant?.offer_price !== null &&
  item.variant?.offer_price !== undefined &&
  item.variant?.offer_price !== ""
    ? Number(item.variant.offer_price)
    : null;

            const hasOffer = offerPrice !== null && offerPrice < productPrice;

            const finalPrice = hasOffer ? offerPrice : productPrice;

            const discountPercent = hasOffer
              ? Math.round(((productPrice - offerPrice) / productPrice) * 100)
              : 0;

            const itemTotal = finalPrice * Number(item.quantity || 1);

            return (
              <div key={item.id} className={styles.cartItem}>
                {/* CHECKBOX */}

                <div className={styles.checkboxCell}>
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item.id)}
                    onChange={() => handleSelectItem(item.id)}
                  />
                </div>

                {/* REMOVE */}

                <div className={styles.removeCell}>
                  <FaTrash
                    size={16}
                    className={styles.removeBtn}
                    title="Remove item"
                    onClick={() => {
                      toast.success("Item removed from cart");

                      removeItem(item.id);
                    }}
                  />
                </div>

                {/* IMAGE */}

                <Link
                  to={`/productdetails/${item.product.slug}`}
                  className={styles.imageCell}
                >
                  <Image
                    src={getImageUrl(item.product.thumb_image)}
                    alt={item.product.name}
                    className={styles.productImage}
                  />
                </Link>

                {/* PRODUCT */}

               {/* PRODUCT */}

{/* PRODUCT */}

<div className={styles.productInfoWrapper}>

  {/* PRODUCT NAME + SKU */}
  <Link
    to={`/productdetails/${item.product.slug}`}
    className={styles.productCell}
  >
    <strong>{item.product.name}</strong>

    {item.product.sku && (
      <span className={styles.productSku}>
        SKU: {item.product.sku}
      </span>
    )}
  </Link>

  {/* SIZE + COLOR - NOT CLICKABLE */}
  {(item.variant?.size || item.variant?.color_name) && (
    <div className={styles.variantInfo}>

      {item.variant?.size && (
        <span className={styles.variantChip}>
          <span className={styles.variantLabel}>Size -</span>
          <span className={styles.variantValue}>
            {item.variant.size}
          </span>
        </span>
      )}

      {item.variant?.color_name && (
        <span className={styles.variantChip}>
          <span className={styles.variantLabel}>Color -</span>
          <span className={styles.variantValue}>
            {item.variant.color_name}
          </span>
        </span>
      )}

    </div>
  )}

  {/* EDIT BUTTON */}
 

</div>

                {/* PRICE */}

                <div className={styles.priceCell}>
                  <div className={styles.priceBlock}>
                    <div className={styles.finalPrice}>
                      <LiaRupeeSignSolid size={15} />

                      {finalPrice.toLocaleString("en-IN")}
                    </div>

                    {hasOffer && (
                      <div className={styles.priceMeta}>
                        <span className={styles.originalPrice}>
                          <LiaRupeeSignSolid size={12} />

                          {productPrice.toLocaleString("en-IN")}
                        </span>

                        <span className={styles.discountBadge}>
                          {discountPercent}% OFF
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* QUANTITY */}

                <div className={styles.quantityCell}>
                  <div className={styles.quantityInputWrapper}>
                    <input
                      readOnly
                      type="number"
                      value={item.quantity}
                      className={styles.quantityInputField}
                    />

                    <div className={styles.quantityArrows}>
                      <Button
                        style={styles.arrowBtn}
                        disabled={isMaxReached}
                        title={<FaChevronUp size={10} />}
                        onHandler={() => {
                          if (isMaxReached) return;

                          updateQuantityInc(item.product_id);
                        }}
                      />

                      <Button
                        style={styles.arrowBtn}
                        disabled={item.quantity <= 1}
                        title={<FaChevronDown size={10} />}
                        onHandler={() =>
                          updateQuantityDec(item.product_id, item.quantity)
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* TOTAL */}

              {/* TOTAL */}

<div className={styles.totalCell}> 

  <div className={styles.totalPrice}>
    <LiaRupeeSignSolid size={15} />
    {itemTotal.toLocaleString("en-IN")}
  </div>

 

</div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default CartMainContent;
